const CountryInfo = function () {



    let isFetch = false;


    const createApiEndpoint = function (countryId = null, stateId = null, cityId = null) {
        let url = `${apiUrl}/v1/GetCountryInfo/${countryId}`;

        if (stateId !== null) {
            url += `/${stateId}`;
        }

        if (cityId !== null) {
            url += `/${cityId}`;
        }

        // console.log(url);

        return url;
    }


    const fetchData = function (apiEndpoint, stateElement, cityElement) {


        if (isFetch) {
            return;
        }

        isFetch = true;
        return new Promise((resolve, reject) => {
            fetch(apiEndpoint)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Bağlantı hatası');
                    }
                    return response.json();
                })
                .then(data => {
                    // console.log(data);

                    if (data.type == 'state') {

                        var newOption = new Option('', '', false, false);
                        $(stateElement).append(newOption).trigger('change');

                        data.rows.forEach(item => {
                            if ($(stateElement).find("option[value='" + item.id + "']").length) {

                            } else {
                                var newOption = new Option(item.name, item.name, false, false);
                                newOption.setAttribute('data-state-id', item.id);
                                $(stateElement).append(newOption).trigger('change');
                            }
                        });

                        $(stateElement).select2('open')
                    }

                    else if (data.type == 'cities') {

                        var newOption = new Option('', '', false, false);
                        $(cityElement).append(newOption).trigger('change');


                        data.rows.forEach(item => {
                            var newOption = new Option(item.name, item.name, false, false);
                            newOption.setAttribute('data-city-id', item.id);
                            $(cityElement).append(newOption).trigger('change');
                        });

                        $(cityElement).select2('open')
                    }

                    resolve();
                })
                .catch(error => {
                    console.error('Hata:', error);
                    reject(error);
                })
                .finally(() => {
                    isFetch = false;
                });
        });
    }


    const formHandle = function (form) {

        const countrySelectElement = form.querySelector('[data-element-country]');
        const stateSelectElement = form.querySelector('[data-element-state]');
        const citySelectElement = form.querySelector('[data-element-city]');


        let countryId;
        let stateId;


        $(countrySelectElement).on('select2:select', function (e) {

            let id = $(this).find(":selected").data("country-id");

            countryId = id;

            $(stateSelectElement).empty().val(null).trigger('change');
            $(citySelectElement).empty().val(null).trigger('change');


            const apiEndpoint = createApiEndpoint(countryId);
            fetchData(apiEndpoint, stateSelectElement, citySelectElement);
        });

        $(stateSelectElement).on('select2:select', function (e) {

            let id = $(this).find(":selected").data("state-id");

            stateId = id;

            $(citySelectElement).empty().val(null).trigger('change');

            const apiEndpoint = createApiEndpoint(countryId, stateId);
            fetchData(apiEndpoint, stateSelectElement, citySelectElement);
        });

        $(citySelectElement).on('change', function (e) {

        });

        $(countrySelectElement).on('change', function (e) {
            let id = $(this).find(":selected").data("country-id");

            countryId = id;

            $(stateSelectElement).empty().val(null).trigger('change');
            $(citySelectElement).empty().val(null).trigger('change');


            const apiEndpoint = createApiEndpoint(countryId);
            fetchData(apiEndpoint, stateSelectElement, citySelectElement);

        });
    }

    return {
        init: function () {

            const addressForms = document.querySelectorAll('#canvasShippings, #canvasInvoices');
            if (!addressForms.length) {
                return;
            }

            addressForms.forEach(function (form) {
                formHandle(form)
            });

        }
    };
}();



$(function () {

    $('[data-type="select2-csc"]').each(function () {
        $(this).select2({
            dropdownParent: $(this).parent(),
            language: langCodeShort
        });
    });


    CountryInfo.init();
});
